/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { MouseEvent, useState } from 'react'
import { IconButton, IconButtonProps, InputAdornment } from '@mui/material'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { FieldValues } from 'react-hook-form/dist/types/fields'
import CustomTextField, { CustomTextFieldElementProps } from './CustomTextField'
import { useWatch } from 'react-hook-form'

export type CustomPasswordElementProps<T extends FieldValues> = CustomTextFieldElementProps<T> & {
    isWithRepeat?: boolean,
    name:string
    label:string
}

export default function CustomPasswordElement<TFieldValues extends FieldValues>({
    isWithRepeat = false,
    name,
    label,
    ...props
}: CustomPasswordElementProps<TFieldValues>): JSX.Element {
    const [password, setPassword] = useState<boolean>(true)
    const [confirmPassword, setConfirmPassword] = useState<boolean>(true)

    const pwValue = useWatch({
        name: name,
        control: props.control
    })

    return (
        <>
            <CustomTextField
            style={{ marginTop: '0px', marginBottom: '16px' }} className="lowHeight"
                 name={name}
                 label={label}
                //  onPaste={(e)=>{
                //     e.preventDefault()
                //     return false;
                //   }}
                {...props}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position={'end'}>
                            <IconButton
                                onMouseDown={(e: MouseEvent<HTMLButtonElement>) =>
                                    e.preventDefault()
                                }
                                onClick={() => setPassword(!password)}
                                tabIndex={-1}
                                color='default'
                            >
                                {password ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    )
                }}
                type={password ? 'password' : 'text'}
            />
       
       { isWithRepeat && 
            <CustomTextField {...props}
                style={{ marginTop: '0px', marginBottom: '16px' }} className="lowHeight"
                name={name+"_repeat"}
                label={'Confirm '+ label +'.'}
                // onPaste={(e)=>{
                //     e.preventDefault()
                //     return false;
                //   }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position={'end'}>
                            <IconButton
                                onMouseDown={(e: MouseEvent<HTMLButtonElement>) =>
                                    e.preventDefault()
                                }
                                onClick={() => setConfirmPassword(!confirmPassword)}
                                tabIndex={-1}
                                color='default'
                            >
                                {confirmPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    )
                }}
                type={confirmPassword ? 'password' : 'text'}
                validation={{
                    validate: (value: string) => {
                        // return value === pwValue || 'Password should match'
                        return value === pwValue || 'new password does not match'
                    }
                }}
                />
            }
           
        </>

    )
}